<template>
  <div class="base-grid-tag" :class="[gridTagClass, { 'is-actionable': isActionable, selected: isSelected }]">
    <BaseIcon v-if="icon" :name="icon" class="base-grid-tag__icon" />
    <span class="base-grid-tag__content" :class="{ expanded: isExpanded }">
      {{ value.value }}
    </span>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import { mapGetters } from 'vuex';

export default {
  name: 'BaseGridTag',
  components: {
    BaseIcon,
  },
  props: {
    icon: {
      type: String,
      required: false,
    },
    isActionable: {
      type: Boolean,
      required: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selected: false,
    };
  },
  computed: {
    ...mapGetters('annotations', ['selectedAnnotation']),
    isSelected() {
      return this.selected;
    },
    gridTagClass() {
      if (this.value.source === 'LLM_EXTRACTION') {
        return `llm ${this.isExpanded ? 'expanded' : ''}`;
      }
      return '';
    },
  },
  watch: {
    selectedAnnotation() {
      if (this.selectedAnnotation && this.selectedAnnotation.id === this.value.textAnnotationId) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    },
    // renderingCompleted: {
    //   handler() {},
    // },
  },
};
</script>

<style lang="scss">
.base-grid-tag {
  background-color: $color-border;
  border-radius: $border-radius-small;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  font-size: $font-size-small;
  margin: 4px;
  gap: 8px;

  &__content {
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.expanded {
      white-space: pre-wrap;
    }
  }

  &__icon {
    color: grey !important;
    flex-grow: 0;
    width: 14px;

    &.base-icon {
      width: 14px !important;
      height: 14px !important;
    }
  }

  &.is-actionable {
    background-color: $color-text-annotation;

    &:hover {
      background-color: $color-text-annotation-hover;
      transition: all 150ms ease-in;
    }

    &.selected {
      background-color: $color-text-annotation-hover;
    }
  }

  // Variations
  &.llm {
    background-color: rgba($color-semantic-ai, 0.4);
    transition: all 150ms ease-in;

    &:hover,
    &.expanded {
      background-color: rgba($color-semantic-ai, 0.55);
      transition: all 150ms ease-in;
    }
  }
}
</style>
